//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['inscricao', 'titulo', 'imagem', 'categoria', 'slug', 'professores'],
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    setImage() {
      if (this.$imagine) {
        let img = this.$imagine(
          this.imagem ? this.imagem : '/portal-turismo/banner.jpg'
        )

        let size = this.$sc.desktopAndUp
          ? '77%'
          : this.$sc.isCell
          ? 'cover'
          : '140%'
        return `linear-gradient(#000000b5, #000000b5), url(${img}) center / ${size} no-repeat`
      }
    },
  },
}
